import { Grid } from '@material-ui/core';
import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledSmallButton = styled(Grid, {
    shouldForwardProp: prop => prop !== 'marginLeft'
}) `
	margin-left: ${(props) => props.marginLeft || 0};
	button,
	button:hover {
		color: ${(props) => props.color};
	}
`;
export const StyledAddCommentButton = styled(Grid, {
    shouldForwardProp: prop => prop !== 'marginLeft'
}) `
	margin-left: ${(props) => props.marginLeft || 0};
    margin: 0 auto;
    margin-bottom: ${Magnetic.spacer24};
	button,
	button:hover {
		color: ${(props) => props.color};
	},
`;
//# sourceMappingURL=PhotoCaptureNavigationControlComponent.style.js.map